angular.module("digiexam.components", [
	"digiexam.services",
	"dx.webapp.cookies",
]);
